export const SUPPORTED_LANGUAGES = ['en', 'fr', 'de', 'es', 'it'] as const;
export const DEFAULT_LANGUAGE = 'en';

export const LANGUAGE_NAMES = {
  en: 'English',
  fr: 'Français',
  de: 'Deutsch',
  es: 'Español',
  it: 'Italiano'
} as const;

export const LANGUAGE_METADATA = {
  en: { dir: 'ltr', weight: 1 },
  fr: { dir: 'ltr', weight: 2 },
  de: { dir: 'ltr', weight: 3 },
  es: { dir: 'ltr', weight: 4 },
  it: { dir: 'ltr', weight: 5 }
} as const;